import React, { useContext } from 'react';
import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { InventoryBundleComponent } from './bundle-component';
import { messages } from './messages';
import bundleStyle from './style.module.less';
import Global from '../../../../../../store/global-selectors';
import { BundleContext } from '../../../../bundle-context';

export const BundleInventory = () => {
  const { bundleComponents } = useContext(BundleContext);

  const components = useSelector((state) => {
    return bundleComponents
      .filter((bc) => bc.productId)
      .map((bc) => {
        const entity =
          Global.selectEntitiesProductsById(state, {
            productId: bc.productId,
          }) ?? {};
        return {
          ...bc,
          sku: entity.sku,
          name: entity.name,
          inventory: entity.inventory,
          quantity: bc.quantity,
        };
      });
  });

  const total = Math.floor(
    Math.min(...components.map((c) => (!c.inventory?.available || !c.quantity ? 0 : c.inventory.available / c.quantity))),
  );

  return (
    <>
      <div className={classnames(bundleStyle['total-available-title'])}>
        <FormattedMessage {...messages.productBundleInventoryTotalAvailable} values={{ total }} />
      </div>
      <Text
        className={classnames(bundleStyle['total-available-helper-text'])}
        textType={TextType.Description}
        value={messages.bundleTotalAvailableNoteHelperText}
      />
      <BannerMessageV2
        className={classnames(bundleStyle['banner-bundle-note'])}
        content={<Text textType={TextType.Paragraph} value={messages.bundleInventoryHelperText} />}
        layout={BannerLayout.Inline}
        status={BannerStatus.Info}
      />
      <div className={classnames(bundleStyle['bundle-component-header-text'])}>
        <FormattedMessage {...messages.productBundleComponentsInventoryTitle} />
      </div>
      <div className={bundleStyle.components}>
        <div className={bundleStyle['component-wrapper']}>
          <div className={bundleStyle['component-header']}>
            <div>
              <FormattedMessage {...messages.productBundleComponent} />
            </div>
            <div className={bundleStyle.quantity}>
              <FormattedMessage {...messages.productBundleComponentOnHand} />
            </div>
            <div className={bundleStyle.quantity}>
              <FormattedMessage {...messages.productBundleComponentQtyRequired} />
            </div>
            <div className={bundleStyle.quantity}>
              <FormattedMessage {...messages.productBundleComponentAllocated} />
            </div>
            <div className={bundleStyle.quantity}>
              <FormattedMessage {...messages.productBundleComponentAvailable} />
            </div>
          </div>
          {components.map((component) => {
            return (
              <InventoryBundleComponent
                key={component.productId}
                inventory={component.inventory}
                name={component.name}
                productId={component.productId}
                quantity={component.quantity}
                sku={component.sku}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};
